<template>
  <modal width="55" v-loading="loading" title="Trip Summary " :show-modal="showModal"
    @close-modal="$emit('close-modal')">
    <section>
      <div class="mt-4 rounded p-3">

        <div v-if="(shipping && shipping.tripId) && isLoading" class="flex py-12 flex-wrap mt-3">
          <div class="w-full flex justify-center">
            <span class="loader">
              <img src="@/assets/images/ondemand/loader.svg" /></span>
          </div>
          <p class="w-full text-center pt-4 px-3">
            Fetching Dispatcher {{ liveTripData.id ? "Update" : "Details" }}...<br />
            Might take a while, Please be patient.
          </p>
        </div>
        <div v-else-if="tripD2d && isLoading" class="flex py-12 flex-wrap mt-3 justify-center">
          No active trip
        </div>
        <div v-if="tripD2d && !isLoading" class="mb-4">
          <div class="flex flex-wrap justify-between">
            <div class="both_section_wrapper">
              <div class="left_section">
                <div class="image_wrapper"> <img class="dispatcher_img"
                    :src="shippingDetail.driver ? shippingDetail.driver.imageurl : ''" /></div>
              </div>
              <div class="right_section">
                <h2 class="name_header">{{ shippingDetail.driver ? shippingDetail.driver.firstname : "" }}
                  {{
                    shippingDetail.driver
                      ? shippingDetail.driver.lastname
                      : ""
                  }}</h2>
                <p class="text-sm">Trusted Partner</p>
                <span class="rate_tag"><span><img class="star_logo" src="../../icons/star.svg" />{{
                  shippingDetail.rating
                    ? shippingDetail.rating.avgRating : 0 }}</span>
                  ({{ shippingDetail.rating ? shippingDetail.rating.totalRatings : 0 }}
                  Ratings)</span>
              </div>
            </div>
            <div class="detail_wrapper">
              <div class="desc_dispatcher_wrapper">
                <label>phone number:</label>
                <span>{{
                  shippingDetail && shippingDetail.driver && shippingDetail.driver.mobile_no
                    ? shippingDetail?.driver?.mobile_no
                    : "N/A"
                }}</span>
              </div>
              <div class="desc_dispatcher_wrapper">
                <label>fleet:</label>
                <span>{{
                  shippingDetail && shippingDetail.fleet
                    ? shippingDetail?.fleet?.vehicletype
                    : "N/A"
                }}</span>
              </div>
              <div class="desc_dispatcher_wrapper">
                <label>Vehicle model:</label>
                <span class=" capitalize">{{
                  shippingDetail && shippingDetail.fleet && shippingDetail.fleet.equipment
                    ? shippingDetail.fleet.equipment
                    : "N/A"
                }}</span>
              </div>
              <div class="desc_dispatcher_wrapper">
                <label>vehicle number:</label>
                <span class="uppercase">{{
                  shippingDetail && shippingDetail.fleet
                    ? shippingDetail.fleet.vehicleNumber
                    : "N/A"
                }}</span>
              </div>
              <div class="desc_dispatcher_wrapper">
                <label>trip status:</label>
                <span class="block w-6/12 text-right whitespace-nowrap capitalize" :class="[
                  true ? statusBg(shipping_ ? shipping_.deliveryStatus : null) : null,
                ]">{{
                  shipping_.deliveryStatus ? shipping_.deliveryStatus : "N/A"
                  }}</span>
              </div>
            </div>
          </div>
        </div>


        <section class="rounded-2xl bg-slate-100 p-3 ">
          <div class="shipment_reciever_wrapper">
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">Shipping ID</span>
              <span class="flex w-6/12 text-right items-center justify-end">{{
                shipping && shipping.shippingReference
                  ? shipping.shippingReference
                  : "N/A"
              }}
                <button @click="isMinimize = !isMinimize" class="text-primary-yellow text-3xl ml-2">
                  {{ isMinimize ? "&minus;" : "&plus;" }}
                </button>
              </span>
            </div>
            <div class="flex pb-2 items-center" v-if="isMinimize">
              <span class="block w-6/12 text-gray-500">Description</span>
              <span class="w-6/12 flex items-center justify-end">{{ totalpackageDiscription }}
              </span>
            </div>
            <div class="flex pb-2" v-if="isMinimize">
              <span class="block w-6/12 text-gray-500">Receiver</span>
              <span class="block w-6/12 text-right">{{
                receieverContactName
              }}
              </span>
            </div>
            <div class="flex pb-2" v-if="isMinimize">
              <span class="block w-6/12 text-gray-500">Sender</span>
              <span class="block w-6/12 text-right">{{
                shipping && shipping.shipperlocation && shipping.shipperlocation.contactName
                  ? shipping.shipperlocation.contactName
                  : "N/A"
              }}
                ({{
                  shipping && shipping.shipperlocation && shipping.shipperlocation.mobile
                    ? shipping.shipperlocation.mobile
                    : "N/A"
                }})</span>
            </div>
          </div>

          <div class="mt-2  pb-1 border-gray-300">
            <div class="flex pb-2" v-if="shipping_.deliveryStatus == 'accepted'">
              <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
              <span class="block w-6/12 text-right" v-if="shouldShowMap">{{displayPickupTime()}}</span>
              <span class="block w-6/12 text-right" v-else>
                {{
                  shipping ? momentFormat(shipping.pickUpDays) : "N/A"
                }}
                | {{ shipping.pickUpTime ? shipping.pickUpTime[0] : "N/A" }}
              </span>
            </div>
            <div class="flex pb-2" v-if="shipping_.deliveryStatus == 'in-transit' || shipping_.deliveryStatus == 'picked_up'">
              <span class="block w-6/12 text-gray-500">Estimated Delivery time</span>
              <span class="block w-6/12 text-right" v-if="shouldShowMap">
                {{ shippingDetail.eta ? shippingDetail.eta : 'N/A' }}
              </span>
              <span class="block w-6/12 text-right" v-else>
                {{
                  shipping.deliveryDays
                    ? momentFormat(shipping.deliveryDays)
                    : "N/A"
                }}
                | {{ shipping.deliveryTime ? shipping.deliveryTime[0] : "N/A" }}
              </span>
            </div>
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">Payment status </span>
              <span class="block w-6/12 text-right capitalize">{{
                shipping ? shipping.paymentStatus : ''
              }}</span>
            </div>
          </div>
        </section>




        <div>

        </div>
        <div class="mt-5 flex justify-end gap-4">
          <button @click="$emit('close-modal')">Close</button>
          <button v-if="isD2D" class="px-3 py-2 bg-primary-yellow rounded-md"
            @click="$emit('open-message')">Message</button>
        </div>
      </div>
    </section>
  </modal>
</template>

<script>
import moment from "moment";
import SocketioService from "../../../../../services/socketio.service";
import { shippingMethods } from '@/components/constant/onboardingType.js'

export default {
  components: {},
  props: {
    center: {
      type: Object,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      if (!this.isD2D) return;
      this.socketEventName = this.shipping?.id;
      if (this.shipping.id) {
        if (val && this.shouldShowMap) {
          this.getShipping(this.shipping.id)
        }
      }

      if (!val) {
        this.isLoading = false;
        this.$store.dispatch("saveNewCurrentShipping", {});
      }
    },
    mapCordinate(val) {
      console.log("changed---cordinate", val);
    },
    shipping() {
      this.mapCordinate = this.center;
      this.liveTripData = {}
    },
  },
  mounted() {
    SocketioService.setupSocketConnection();
  },
  methods: {
    getETA(driverLat, driverLong, destLat, destLong, averageSpeedKmh) {
      if (
        driverLat == null || driverLong == null ||
        destLat == null || destLong == null
      ) {
        return null;
      }

      averageSpeedKmh = averageSpeedKmh || 40;

      const toRad = function (value) {
        return value * Math.PI / 180;
      };

      const R = 6371; // Earth radius in km
      const dLat = toRad(destLat - driverLat);
      const dLon = toRad(destLong - driverLong);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(driverLat)) * Math.cos(toRad(destLat)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distanceKm = R * c;

      const etaMinutes = Math.round((distanceKm / averageSpeedKmh) * 60);

      if (etaMinutes < 1) return "less than a minute";
      if (etaMinutes < 60) return etaMinutes + " min" + (etaMinutes > 1 ? "s" : "");

      const days = Math.floor(etaMinutes / (60 * 24));
      const hours = Math.floor((etaMinutes % (60 * 24)) / 60);
      const minutes = etaMinutes % 60;

      const parts = [];
      if (days > 0) parts.push(days + " day" + (days > 1 ? "s" : ""));
      if (hours > 0) parts.push(hours + " hour" + (hours > 1 ? "s" : ""));
      if (minutes > 0) parts.push(minutes + " min" + (minutes > 1 ? "s" : ""));

      return parts.join(" ");
    },
    statusBg(val) {
      let bg = "";
      switch (val) {
        case "paid":
          bg = "text-red-500";
          break;

        case "pending":
          bg = "text-primary-yellow";
          break;

        case "in-transit":
          bg = "text-primary-yellow";
          break;

        case 'accepted':
          bg = "text-teal-500";
          break;
        case 'Picked_up':
          bg = "text-teal-500";
          break;

        default:
          bg = "text-teal-500";
          break;
      }
      return bg;
    },
    async getShipping(id) {
      try {
        this.isLoading = true;
        const response = await this.$_getCreatedNewBooking(id);
        this.shippingDetail = response.data.data;
        this.shipping_ = response.data.data?.shipping
      } catch (error) {
        this.error = error;
      } finally {
        this.isLoading = false;
      }

    },
    momentFormat(val) {
      return moment(val).format("MMMM Do YYYY")
    },
    async getTripMessages() {
      try {
        await this.$apollo
          .query({
            query: this.$_GraphQL_Endpoint.getMessagesTrip,
            variables: { tripId: this.shipping?.tripId },
            fetchPolicy: 'no-cache'
          }).then((res) => {
            this.chatMessages = this.groupMessages(res.data.getMessages.data)
          })
      } catch (error) {
        //
      }
    },
    displayPickupTime() {
      // Input iOS date string            
      const iosDateString = this.shippingDetail?.origin?.departure_time;

      // Format the new date as "YYYY-MM-DD, hh:mm"
      const formattedDate = moment(iosDateString).format("YYYY-MM-DD, hh:mm");
      return formattedDate || "N/A";
    },
    changeTimeFormat(val) {
      return moment(val).format("DD-MM-YYYY, hh:mm") ?? "";
    },
  },
  computed: {
    tripD2d(){
        return this.isD2D && this.shipping?.tripId
    },
    getDriverETA() {
      const { origin, destination, driver, shipping } = this.shippingDetail
      const destLat = shipping.deliveryStatus == 'accepted' ? origin?.lat : destination?.lat;
      const destLong = shipping.deliveryStatus == 'accepted' ? origin?.long : destination?.long;
      const driverLat = driver?.location?.latitude || 0;
      const driverLong = driver?.location?.longitude || 0;

      let Eta = this.getETA(driverLat, driverLong, destLat, destLong, 40)
      return Eta
    },
    receieverContactName() {
      return (this.shipping?.shipmentReceiever || []).map((item) => item?.location?.contactName || item?.location?.name || "N/A").join(",")
    },
    contact_Person() {
      return (
        this.shipping?.consigneelocation?.contactPerson ||
        this.shipping?.consigneelocation?.contactName ||
        "N/A"
      );
    },
    totalpackageDiscription() {
      if ((this.shipping?.shipmentReceiever || []).length < 1) return "";
      const desc = (this.shipping?.shipmentReceiever || [])
        .flatMap(receiver => receiver?.packagees || [])
        .map(pkg => pkg?.description)
        .join(", ");
      return desc
    },
    Dispatcher() {
      let handler = this.liveTripData?.trip?.fleet?.vehicleType?.toLowerCase();
      switch (handler) {
        case "bike":
          handler = "Rider of Bike";
          break;
        case "truck":
          handler = "Driver of Truck";
          break;
        case "car":
          handler = "Driver of Car";
          break;
        default:
          break;
      }
      return handler;
    },
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
    isD2D() {
      return this.shipping?.shippingMethod === shippingMethods.D2D;
    },
    ratings() {
      const allRatings = this.liveTripData?.rating?.shippings || [];
      const averageRating = allRatings.length > 0 ? allRatings.reduce((sum, item) => sum + item?.rating, 0) / allRatings.length : 0;
      return { rate: averageRating, ratingsTotal: allRatings.length }
    },
    shouldShowMap() {
      return (
        this.shipping?.shippingMethod === "door-to-door" ||
        (this.shipping?.shippingMethod === "terminal-to-door" &&
          !this.shipping?.shippingservice)
      );
    },
  },
  data() {
    return {
      loading: false,
      isMinimize: true,
      mapCordinate: [],
      dispatcher: {},
      socketEventName: "",
      status: "",
      liveTripDatashipping: {},
      tripsDetails: {},
      isLoading: false,
      interval: null,
      chatMessages: [],
      shippingDetail: {},
      shipping_: {},
      error: null
    };
  },
  beforeDestroy() {
    SocketioService.disconnect();
    this.sockets.unsubscribe(this.shipping.id);
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: inline-block;
  width: auto;
  height: auto;
  animation: 2s infinite linear rolls;
}

@keyframes rolls {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.image_wrapper {
  @apply w-[100px] h-[100px] lg:w-[100px] lg:h-[100px] inline-block mb-3 lg:mb-0
}

.dispatcher_img {
  @apply w-[100px] h-[100px] lg:w-[100px] lg:h-[100px] rounded-full border border-yellow-200 bg-slate-200
}

.left_section {
  @apply w-auto lg:w-4/12 flex md:justify-center
}

.right_section {
  @apply w-full lg:w-7/12
}

.both_section_wrapper {
  @apply w-full lg:w-6/12 flex flex-wrap justify-center md:justify-between items-center relative lg:border-r-[1px] lg:border-r-slate-300 mb-4
}

.name_header {
  @apply text-lg font-semibold
}

.rate_tag {
  @apply text-xs text-slate-500;

  span {
    @apply inline-flex px-2 bg-slate-100 rounded-xl gap-1 items-center
  }
}

.desc_dispatcher_wrapper {
  @apply flex justify-between items-center text-sm;

  label {
    @apply uppercase text-slate-400
  }
}

.detail_wrapper {
  @apply w-full lg:w-[46%] mb-4
}

.star_logo {
  @apply w-[9px]
}
.shipment_reciever_wrapper{
  @apply mt-2 border-b-[1px] pb-1 border-dashed border-gray-300
}
</style>
